import {
	faPaperPlane,
	faPhone,
	faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch } from "react-redux";
import "../Menu.css";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { getDataAPI, postDataAPI } from "../utils/fetchData";
import Footer from "./footer";
import Homecarousel from "./homecarousel";
import Navbar from "./navbar";

const JobSeeker = () => {
	const [formData, setFormData] = useState({
		name: "",
		email: "",
		mobile: "",
		gender: "Gender",
		profilepic: "",
		linkedin_profile: "",
		educationalqualifications: "",
		f_s_s_intersted: "Food Safety Standard Interested",
		employmenttype: "Employment Type",
		jobtype: "Job Type",
		city: "",
		country: "",
		salaryrange: "",
		areasofexpertise: "",
		yearsofexperience: "",
		availability: "Availability",
		additionalinformation: "",
		resume: "",
	});

	const genderRef = useRef(null);
	const f_s_s_interstedRef = useRef(null);
	const employmentRef = useRef(null);
	const jobRef = useRef(null);
	const availabilityRef = useRef(null);
	const dispatch = useDispatch();

	const [genderOpen, setIsgenderOpen] = useState(false);
	const [isf_s_s_interstedOpen, setIsf_s_s_interstedOpen] = useState(false);
	const [empOpen, setIsempOpen] = useState(false);
	const [jobOpen, setIsjobOpen] = useState(false);
	const [isAvailabilityOpen, setIsAvailabilityOpen] = useState(false);
	const [alljobs, setAlljobs] = useState([]);
	const [jobseekersCount, setJobseekersCount] = useState("");
	const [searchTerm, setSearchTerm] = useState("");
	const [errors, setErrors] = useState({});
	const lengthOftext = 200;

	const genderOptions = ["Gender", "Male", "Female"];
	const f_s_s_interstedOptions = [
		"USDA NOP",
		"Organic NPOP",
		"GlobalG.A.P.",
		"ISO 9001",
		"ISO 22000",
		"FSSC 22000",
		"FSSAI",
		"ISO 14001",
		"USFDA PCQI",
	];

	const empOptions = [
		"Employment Type",
		"Full - Time",
		"Part - Time",
		"Contract",
		"Internship",
	];
	const jobOptions = ["Job Type", "On - Site", "Remote", "Hybrid"];

	const availabilityOptions = [
		"Availability",
		"Immediate",
		"30 Days",
		"90 Days",
	];

	const validateForm = () => {
		const newErrors = {};
		if (!formData.name) {
			newErrors.name = "Name is required.";
		}

		if (!formData.email) {
			newErrors.email = "Email is required.";
		} else if (!/\S+@\S+\.\S+/.test(formData.email)) {
			newErrors.emailInvalid = "Email is invalid.";
		}

		if (!formData.mobile) {
			newErrors.mobile = "Mobile number is required.";
		}
		if (formData.gender === "Gender") newErrors.gender = "Gender is required.";
		if (!formData.educationalqualifications) {
			newErrors.educationalqualifications =
				"Educational qualifications are required.";
		}

		if (formData.f_s_s_intersted === "Food Safety Standard Interested") {
			newErrors.f_s_s_intersted =
				"Food Safety Standard Interested is required.";
		}

		if (formData.employmenttype === "Employment Type") {
			newErrors.employmenttype = "Employment Type is required.";
		}

		if (formData.jobtype === "Job Type") {
			newErrors.jobtype = "Job Type is required.";
		}

		if (!formData.city) {
			newErrors.city = "City is required.";
		}

		// if (!formData.country) {
		// 	newErrors.country = "Country is required.";
		// }

		if (!formData.areasofexpertise) {
			newErrors.areasofexpertise = "Areas of expertise are required.";
		}

		if (!formData.yearsofexperience) {
			newErrors.yearsofexperience = "Years of experience are required.";
		}

		if (formData.availability === "Availability") {
			newErrors.availability = "Availability is required.";
		}

		if (!formData.additionalinformation) {
			newErrors.additionalinformation = "Additional information is required.";
		}

		if (!formData.resume.name) newErrors.resume = "Resume is required.";
		else if (formData.resume.name.split(".").length > 2)
			newErrors.invalidResume = "Select valid pdf format";
		else if (formData.resume.type !== "application/pdf")
			newErrors.invalidResume = "Resume should be in pdf format";

		setErrors(newErrors);
		console.log("newErrors", newErrors);
		return Object.keys(newErrors).length === 0;
	};

	useEffect(() => {
		dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });

		getDataAPI(`getJobseekersCount`).then((res) => {
			console.log("res getJobseekersCount", res.data);
			setJobseekersCount(res.data.jobseekersdetails.total);
		});

		(async () => {
			try {
				const res = await getDataAPI(`getAllJobs`);
				console.log("res", res.data);
				setAlljobs(res.data.jobs);
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { loading: false },
				});
			} catch (err) {
				console.error("Error fetching job seekers:", err);
			}
		})();
	}, []);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (genderRef.current && !genderRef.current.contains(event.target)) {
				setIsgenderOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				f_s_s_interstedRef.current &&
				!f_s_s_interstedRef.current.contains(event.target)
			) {
				setIsf_s_s_interstedOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				employmentRef.current &&
				!employmentRef.current.contains(event.target)
			) {
				setIsempOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (jobRef.current && !jobRef.current.contains(event.target)) {
				setIsjobOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				availabilityRef.current &&
				!availabilityRef.current.contains(event.target)
			) {
				setIsAvailabilityOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	const handlePhoneChange = (value) => {
		setFormData({ ...formData, mobile: value });
	};

	const handleFileChange = (event) => {
		if (event.target.files && event.target.files[0]) {
			console.log("event.target.files[0]", event.target.files[0]);
			if (!event.target.files[0].type.includes("image")) {
				alert("Please select image");
				console.log("setFormData", formData);

				return;
			}
			let reader = new FileReader();
			reader.onload = (e) => {
				setFormData((prevState) => ({
					...prevState,
					profilepic: e.target.result,
				}));
			};
			reader.readAsDataURL(event.target.files[0]);
		}
	};

	const toggleGenderDropdown = () => {
		setIsgenderOpen(!genderOpen);
	};

	const handlegenderSelect = (option) => {
		setFormData((prevState) => ({
			...prevState,
			gender: option,
		}));
		setIsgenderOpen(false);
	};

	const togglef_s_s_interstedDropdown = () => {
		setIsf_s_s_interstedOpen(!isf_s_s_interstedOpen);
	};

	const handlef_s_s_interstedSelect = (option) => {
		setFormData((prevState) => ({
			...prevState,
			f_s_s_intersted: option,
		}));
		setIsf_s_s_interstedOpen(false);
	};

	const toggleEmploymentDropdown = () => {
		setIsempOpen(!empOpen);
	};

	const handleEmploymentSelect = (option) => {
		setFormData((prevState) => ({
			...prevState,
			employmenttype: option,
		}));
		setIsempOpen(false);
	};

	const toggleJobDropdown = () => {
		setIsjobOpen(!jobOpen);
	};

	const handleJobSelect = (option) => {
		setFormData((prevState) => ({
			...prevState,
			jobtype: option,
		}));
		setIsjobOpen(false);
	};

	const toggleAvailabilityDropdown = () => {
		setIsAvailabilityOpen(!isAvailabilityOpen);
	};

	const handleAvailabilitySelect = (option) => {
		setFormData((prevState) => ({
			...prevState,
			availability: option,
		}));
		setIsAvailabilityOpen(false);
	};

	const handleResumeChange = (event) => {
		const file = event.target.files[0];
		console.log("file", file);
		if (file) {
			setFormData((prevState) => ({
				...prevState,
				resume: file,
			}));
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		console.log("validateForm()", validateForm());
		if (!validateForm()) return;
		dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });

		const sendData = new FormData();

		if (formData.resume !== "") {
			sendData.append("files", formData.resume);
		}

		for (var key in formData) {
			sendData.append(
				key,
				typeof formData[key] === "object"
					? JSON.stringify(formData[key])
					: formData[key]
			);
		}

		try {
			const res = await postDataAPI("createjobseekers", sendData);
			if (res.status === 200) {
				alert("Thank you for registering. We will get back to you soon");
				window.location.reload();
			}
		} catch (err) {
			dispatch({
				type: GLOBALTYPES.ALERT,
				payload: { error: err.response.data.msg },
			});
		}
	};

	const searchedData = alljobs.filter(
		(jobseeker) =>
			jobseeker.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
			jobseeker.employer.organisationname
				.toLowerCase()
				.includes(searchTerm.toLowerCase()) ||
			jobseeker.experiencelevel
				.toLowerCase()
				.includes(searchTerm.toLowerCase()) ||
			jobseeker.f_s_s_intersted
				.toLowerCase()
				.includes(searchTerm.toLowerCase()) ||
			jobseeker.city.toLowerCase().includes(searchTerm.toLowerCase()) ||
			jobseeker.country.toLowerCase().includes(searchTerm.toLowerCase())
	);

	return (
		<>
			<Navbar />
			<Homecarousel />
			<div className="tab-m">
				<div id="Tab">
					<ul className="nav1 nav-tabs1">
						<li className="active pb-dl">
							<a href="#1" data-toggle="tab">
								Job Postings
							</a>
						</li>
						<li>
							<a href="#2" data-toggle="tab">
								Submit your application
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div className="tab-content ">
				<div className="tab-pane active" id="1">
					<div style={{ padding: "100px 30px" }}>
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<h4 className="instructorlist-text"></h4>
							<input
								type="text"
								placeholder="Search"
								value={searchTerm}
								onChange={(e) => setSearchTerm(e.target.value)}
								className="mb-4 p-2 border border-gray-300 rounded"
							/>
						</div>
						{searchedData.map((job) => (
							<div key={job.id} className="col-12" style={{ padding: "10px" }}>
								<div className="card" style={{ padding: "5px" }}>
									<div className="row">
										<div className="col-xl-9 col-lg-9 col-md-12 col-sm-12  listofcourses-format">
											<div
												style={{
													fontSize: "20px",
													fontWeight: "500",
													minHeight: "36px",
												}}>
												<label>{job.title}</label>
											</div>
											<div style={{ fontSize: "15px" }}>
												<div>
													Organisation: <b>{job.employer.organisationname}</b>
												</div>
												<div>
													Food Safety Standard Interested:{" "}
													<b>{job.f_s_s_intersted}</b>
												</div>
												<div>
													Experience level: <b>{job.experiencelevel}</b>
												</div>
												<div>
													Work location: <b>{job.city + ", " + job.country}</b>
												</div>
											</div>
										</div>
										<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 listofcourses-format">
											<a href={`/jobinfo/${job.id}`}>
												<button
													className="addinstructor-btn"
													style={{
														background: "rgb(30 243 164)",
														border: "none",
														width: "150px",
													}}>
													View Job
												</button>
											</a>
										</div>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
				<div className="tab-pane" id="2">
					<div className="tab-pane-padding">
						<div className="js">
							<div className="js-box">
								<br />
								<div className="js-heading">
									<h3>Total Applications: {jobseekersCount}</h3>
								</div>
								<div className="js-boxIn">
									<div className="js-boxIn-content">
										<div className="js-greenbox">
											<div>
												<h4 className="js-greenbox-heading">Fill the form</h4>
											</div>
											<div>
												<form onSubmit={handleSubmit}>
													<h4 className="emp-greenbox-heading">
														1. Contact Information
													</h4>
													<div className="js-inputbox">
														<span className="js-inputbox-input">
															<input
																type="text"
																name="name"
																value={formData.name}
																onChange={handleInputChange}
																placeholder="Full Name"
																maxLength={lengthOftext}
															/>
														</span>
														<div className="js-Icon">
															<FontAwesomeIcon icon={faUser} />
														</div>
													</div>
													<p
														style={{
															visibility: errors.name ? "visible" : "hidden",
														}}
														className="error-message">
														Full name is required.
													</p>
													<div className="js-inputbox">
														<span className="js-inputbox-input">
															<input
																type="text"
																name="email"
																value={formData.email}
																onChange={handleInputChange}
																placeholder="Email"
																maxLength={lengthOftext}
															/>
														</span>
														<div className="js-Icon">
															<FontAwesomeIcon icon={faPaperPlane} />
														</div>
													</div>
													<p
														className="error-message"
														style={{
															visibility:
																errors.email || errors.emailInvalid
																	? "visible"
																	: "hidden",
														}}>
														{errors.email ? errors.email : errors.emailInvalid}
														{!errors.email && !errors.emailInvalid && "Text"}
													</p>
													<div className="js-inputbox">
														<span className="js-inputbox-input">
															<div
																className="js-dropdown-container"
																ref={genderRef}>
																<div className="js-dropdown">
																	<div
																		className="js-dropdown-header"
																		onClick={toggleGenderDropdown}>
																		{formData.gender}
																		<span
																			className={`js-dropdown-symbol ${
																				genderOpen ? "open" : ""
																			}`}
																		/>
																	</div>

																	{genderOpen && (
																		<ul className="js-dropdown-list">
																			{genderOptions.map((option, index) => (
																				<li
																					key={index}
																					className="js-dropdown-item"
																					onClick={() =>
																						handlegenderSelect(option)
																					}>
																					{option}
																				</li>
																			))}
																		</ul>
																	)}
																</div>
															</div>
														</span>
														<div className="js-Icon">
															<FontAwesomeIcon icon={faUser} />
														</div>
													</div>
													<p
														style={{
															visibility: errors.gender ? "visible" : "hidden",
														}}
														className="error-message">
														Gender is required.
													</p>
													<div className="js-inputbox">
														<span className="js-inputbox-input">
															<span>Profile pic (Optional):</span>
															<input
																style={{ paddingLeft: "0px" }}
																type="file"
																value={formData.profilepic.name}
																onChange={(e) => handleFileChange(e)}
																accept="image/*"
															/>
														</span>
													</div>
													<p
														style={{
															visibility: errors.pic ? "visible" : "hidden",
														}}
														className="error-message">
														Resume is required.
													</p>
													<div className="js-inputbox">
														<span className="js-inputbox-input">
															<PhoneInput
																country={"in"}
																type="tel"
																name="mobile"
																value={formData.mobile}
																onChange={handlePhoneChange}
																placeholder="Phone Number"
																maxLength={lengthOftext}
															/>
														</span>
														<div className="js-Icon">
															<FontAwesomeIcon icon={faPhone} />
														</div>
													</div>
													<p
														style={{
															visibility: errors.mobile ? "visible" : "hidden",
														}}
														className="error-message">
														Mobile is required.
													</p>
													<div className="js-inputbox">
														<span className="js-inputbox-input">
															<input
																type="text"
																name="linkedin_profile"
																value={formData.linkedin_profile}
																onChange={handleInputChange}
																placeholder="LinkedIn Profile"
																maxLength={lengthOftext}
															/>
														</span>
														<div className="js-Icon">
															<FontAwesomeIcon icon={faUser} />
														</div>
													</div>
													<p
														style={{
															visibility: errors.linkedin_profile
																? "visible"
																: "hidden",
														}}
														className="error-message">
														Resume is required.
													</p>
													<h4 className="emp-greenbox-heading">
														2. Submit a Job Profile
													</h4>
													<div className="js-inputbox">
														<span className="js-inputbox-input">
															<input
																type="text"
																name="educationalqualifications"
																value={formData.educationalqualifications}
																onChange={handleInputChange}
																placeholder="Educational Qualifications"
																maxLength={lengthOftext}
															/>
														</span>
														<div className="js-Icon">
															<FontAwesomeIcon icon={faUser} />
														</div>
													</div>
													<p
														style={{
															visibility: errors.educationalqualifications
																? "visible"
																: "hidden",
														}}
														className="error-message">
														Educational Qualification is required.
													</p>
													<div className="js-inputbox">
														<span className="js-inputbox-input">
															<div
																className="js-dropdown-container"
																ref={f_s_s_interstedRef}>
																<div className="js-dropdown">
																	<div
																		className="js-dropdown-header"
																		onClick={togglef_s_s_interstedDropdown}>
																		{formData.f_s_s_intersted}
																		<span
																			className={`js-dropdown-symbol ${
																				isf_s_s_interstedOpen ? "open" : ""
																			}`}
																		/>
																	</div>

																	{isf_s_s_interstedOpen && (
																		<ul className="js-dropdown-list">
																			{f_s_s_interstedOptions.map(
																				(option, index) => (
																					<li
																						key={index}
																						className="js-dropdown-item"
																						onClick={() =>
																							handlef_s_s_interstedSelect(
																								option
																							)
																						}>
																						{option}
																					</li>
																				)
																			)}
																		</ul>
																	)}
																</div>
															</div>
														</span>
														<div className="js-Icon">
															<FontAwesomeIcon icon={faUser} />
														</div>
													</div>
													<p
														style={{
															visibility: errors.f_s_s_intersted
																? "visible"
																: "hidden",
														}}
														className="error-message">
														FSSI is required.
													</p>
													<div className="js-inputbox">
														<span className="js-inputbox-input">
															<div
																className="js-dropdown-container"
																ref={employmentRef}>
																<div className="js-dropdown">
																	<div
																		className="js-dropdown-header"
																		onClick={toggleEmploymentDropdown}>
																		{formData.employmenttype}
																		<span
																			className={`js-dropdown-symbol ${
																				empOpen ? "open" : ""
																			}`}
																		/>
																	</div>

																	{empOpen && (
																		<ul className="js-dropdown-list">
																			{empOptions.map((option, index) => (
																				<li
																					key={index}
																					className="js-dropdown-item"
																					onClick={() =>
																						handleEmploymentSelect(option)
																					}>
																					{option}
																				</li>
																			))}
																		</ul>
																	)}
																</div>
															</div>
														</span>
														<div className="js-Icon">
															<FontAwesomeIcon icon={faUser} />
														</div>
													</div>
													<p
														style={{
															visibility: errors.employmenttype
																? "visible"
																: "hidden",
														}}
														className="error-message">
														Employment type is required.
													</p>
													<div className="js-inputbox">
														<span className="js-inputbox-input">
															<div
																className="js-dropdown-container"
																ref={jobRef}>
																<div className="js-dropdown">
																	<div
																		className="js-dropdown-header"
																		onClick={toggleJobDropdown}>
																		{formData.jobtype}
																		<span
																			className={`js-dropdown-symbol ${
																				jobOpen ? "open" : ""
																			}`}
																		/>
																	</div>

																	{jobOpen && (
																		<ul className="js-dropdown-list">
																			{jobOptions.map((option, index) => (
																				<li
																					key={index}
																					className="js-dropdown-item"
																					onClick={() =>
																						handleJobSelect(option)
																					}>
																					{option}
																				</li>
																			))}
																		</ul>
																	)}
																</div>
															</div>
														</span>
														<div className="js-Icon">
															<FontAwesomeIcon icon={faUser} />
														</div>
													</div>
													<p
														style={{
															visibility: errors.jobtype ? "visible" : "hidden",
														}}
														className="error-message">
														Job type is required.
													</p>
													<h6 className="emp-greenbox-heading">
														Work Location
													</h6>
													<div className="js-inputbox">
														<span className="js-inputbox-input">
															<input
																type="text"
																name="city"
																value={formData.city}
																onChange={handleInputChange}
																placeholder="City"
																maxLength={lengthOftext}
															/>
														</span>
														<div className="js-Icon">
															<FontAwesomeIcon icon={faUser} />
														</div>
													</div>
													<p
														style={{
															visibility: errors.city ? "visible" : "hidden",
														}}
														className="error-message">
														City is required.
													</p>
													<div className="js-inputbox">
														<span className="js-inputbox-input">
															<input
																type="text"
																name="salaryrange"
																value={formData.salaryrange}
																onChange={handleInputChange}
																placeholder="Salary Range(Optional)"
																maxLength={lengthOftext}
															/>
														</span>
														<div className="js-Icon">
															<FontAwesomeIcon icon={faUser} />
														</div>
													</div>
													<p
														style={{
															visibility: errors.salaryrange
																? "visible"
																: "hidden",
														}}
														className="error-message">
														Salary range is required.
													</p>
													<div className="js-inputbox">
														<span className="js-inputbox-input">
															<input
																type="text"
																name="areasofexpertise"
																value={formData.areasofexpertise}
																onChange={handleInputChange}
																placeholder="Areas of Expertise"
																maxLength={lengthOftext}
															/>
														</span>
														<div className="js-Icon">
															<FontAwesomeIcon icon={faUser} />
														</div>
													</div>
													<p
														style={{
															visibility: errors.areasofexpertise
																? "visible"
																: "hidden",
														}}
														className="error-message">
														Area of expertise is required.
													</p>
													<div className="js-inputbox">
														<span className="js-inputbox-input">
															<input
																type="text"
																name="yearsofexperience"
																value={formData.yearsofexperience}
																onChange={handleInputChange}
																placeholder="Years of Experience"
																maxLength={lengthOftext}
															/>
														</span>
														<div className="js-Icon">
															<FontAwesomeIcon icon={faUser} />
														</div>
													</div>
													<p
														style={{
															visibility: errors.yearsofexperience
																? "visible"
																: "hidden",
														}}
														className="error-message">
														Years of experience is required.
													</p>
													<div className="js-inputbox">
														<span className="js-inputbox-input">
															<div
																className="js-dropdown-container"
																ref={availabilityRef}>
																<div className="js-dropdown">
																	<div
																		className="js-dropdown-header"
																		onClick={toggleAvailabilityDropdown}>
																		{formData.availability}
																		<span
																			className={`js-dropdown-symbol ${
																				isAvailabilityOpen ? "open" : ""
																			}`}
																		/>
																	</div>

																	{isAvailabilityOpen && (
																		<ul className="js-dropdown-list">
																			{availabilityOptions.map(
																				(option, index) => (
																					<li
																						key={index}
																						className="js-dropdown-item"
																						onClick={() =>
																							handleAvailabilitySelect(option)
																						}>
																						{option}
																					</li>
																				)
																			)}
																		</ul>
																	)}
																</div>
															</div>
														</span>
														<div className="js-Icon">
															<FontAwesomeIcon icon={faUser} />
														</div>
													</div>
													<p
														style={{
															visibility: errors.availability
																? "visible"
																: "hidden",
														}}
														className="error-message">
														Availability is required.
													</p>
													<div className="js-inputbox">
														<span className="js-inputbox-input">
															<input
																type="text"
																name="additionalinformation"
																value={formData.additionalinformation}
																onChange={handleInputChange}
																placeholder="Additional Information"
																maxLength={lengthOftext}
															/>
														</span>
														<div className="js-Icon">
															<FontAwesomeIcon icon={faUser} />
														</div>
													</div>
													<p
														style={{
															visibility: errors.additionalinformation
																? "visible"
																: "hidden",
														}}
														className="error-message">
														Additional information is required.
													</p>
													<span>Note: Upload resume in pdf format</span>
													<div className="js-inputbox">
														<span className="js-inputbox-input">
															<span>Resume:</span>
															<input
																style={{ paddingLeft: "0px" }}
																type="file"
																onChange={(e) => handleResumeChange(e)}
																accept="application/pdf"
															/>
														</span>
													</div>
													<p
														className="error-message"
														style={{
															visibility:
																errors.resume || errors.invalidResume
																	? "visible"
																	: "hidden",
														}}>
														{errors.resume
															? errors.resume
															: errors.invalidResume}
														{!errors.resume && !errors.invalidResume && "Text"}
													</p>
													<button type="submit" className="js-submitbtn">
														SUBMIT
													</button>
												</form>
											</div>
										</div>
									</div>
									<div className="js-boxIn-Image">
										<div className="js-boxIn-ImageIn">
											<img src="../images/job.png" alt="job" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<Footer />
		</>
	);
};

export default JobSeeker;
